export default __webpack_public_path__ + "static/media/alamo-arte-6.0ef65f89.webp";